import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";

export default function BrandVoiceTab() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [vibe, setVibe] = useState("");
  const [sample, setSample] = useState("");

  const load = () => http.get("/brand-voice").then(r=>setList(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name) { toast.error("Give your brand voice a name"); return; }
    await http.post("/brand-voice", { name, vibe, sample });
    setName(""); setVibe(""); setSample("");
    toast.success("Brand voice saved");
    load();
  };

  const del = async (id) => {
    await http.delete(`/brand-voice/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="space-y-5">
      <div className="tt-card p-6">
        <h1 className="text-3xl font-black h-tight">Brand voice</h1>
        <p className="text-sm text-zinc-500 mt-1">Save your voice once. TagTitan reuses it on every listing you generate.</p>
        <div className="mt-4 grid md:grid-cols-3 gap-3">
          <input data-testid="bv-name" className="input" placeholder="Name (e.g. Retro Streetwear Co)" value={name} onChange={e=>setName(e.target.value)} />
          <input data-testid="bv-vibe" className="input" placeholder="Vibe (e.g. bold, sarcastic, minimalist)" value={vibe} onChange={e=>setVibe(e.target.value)} />
          <input data-testid="bv-sample" className="input" placeholder="Sample line (e.g. Made for people who wear coffee, not tea.)" value={sample} onChange={e=>setSample(e.target.value)} />
        </div>
        <div className="mt-3 flex justify-end">
          <button data-testid="bv-save" onClick={create} className="btn-primary inline-flex items-center gap-1"><Plus size={14} /> Save voice</button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {list.map(v => (
          <div key={v.id} className="tt-card p-5" data-testid={`bv-item-${v.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="text-lg font-extrabold h-tight">{v.name}</div>
                <div className="text-xs uppercase tracking-widest text-zinc-500 mt-1">{v.vibe}</div>
              </div>
              <button onClick={()=>del(v.id)} className="text-zinc-400 hover:text-red-500"><Trash2 size={16} /></button>
            </div>
            <div className="mt-3 text-sm italic text-zinc-700">"{v.sample}"</div>
          </div>
        ))}
        {list.length === 0 && <div className="text-sm text-zinc-500">No saved voices yet.</div>}
      </div>
    </div>
  );
}
